import React from 'react';
import { BrowserRouter, Route,Routes } from 'react-router-dom';
import AcercaDe from './componentes/AcercaDe';
import Inicio from './componentes/Inicio';
import Header from './componentes/Header';
import styled from 'styled-components';
import Post from './componentes/Post';
import Error404 from './componentes/Error404';
import Contacto from './componentes/Contacto';
import circuitos2 from './images/circuitos2.png';
import ListaProductos from './data/ListaProductos';
import {Helmet} from "react-helmet"; 
import favicon from './images/iconoEH.png';


const App = () => {
  return ( 
    <>
    <Helmet>
      <link rel="shortcut icon" href={favicon} type="image/x-icon"></link>
      <title>EH</title>
    </Helmet>
     <BrowserRouter>
            <ContenedorPrincipal>
                <Header></Header>
                <Main>
                  <Routes>
                    <Route path='*' element={ <Error404/> }> </Route>
                    <Route path='/' element={ <Inicio/> }> </Route>
                    <Route path='/producto' element={
                        <ListaProductos></ListaProductos>
                    }>
                    </Route>
                    <Route path='/post/:id' element={<Post>
                                                  </Post>
                                                  }>
                     </Route>
                     <Route path='/contacto' element={
                        <Contacto></Contacto>
                    }></Route> 
                    <Route path='/acerca-de' element={
                          <AcercaDe></AcercaDe>
                    }>

                    </Route>
                  </Routes>
                 
                   
                </Main>
              
            </ContenedorPrincipal>
          </BrowserRouter>
    </>
         
          );
}



const ContenedorPrincipal= styled.div`
    max-width: 1800px;
    padding: 20px;
    width: 100%;
    display: grid;
    gap: 20px;
    backgroundImage:url(${circuitos2});
   
    margin: 10px 0;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(129, 129, 129, 0.1);


    @media(max-width: 60rem){ /* 950px */
    display: flex;
    flex-direction: column-reverse;
    align-items: center;

    & > div {
        display: flex;
        margin-bottom: 1.25rem; /* 20px */
        justify-content: end;
    }
}
`;


const Main= styled.main`
   background:#fff;
   padding:20px;
   border-radius:10px;
   box-shadow: 0px,0px,5px rgba(129,129,129,0.1);
`;
export default App;